export default {"src":"/_next/static/media/other-id.6963ee50.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};